import head from "lodash/head";
import { CVUpload } from "PFApp/profiles/common/cv_upload";
import { useGrowlStoreActions } from "PFApp/stores/growl_store";
import { gidToPath } from "PFCore/helpers/gid";
import { useCurrentProfile } from "PFCore/hooks/queries/profile/use_current_profile";
import { fetchChangeRequests } from "PFCore/services/change_requests/fetch_change_requests";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

export const CvUploader = () => {
  const navigate = useNavigate();
  const { data: currentProfile } = useCurrentProfile();
  const { t } = useTranslation("profiles", { keyPrefix: "common.cvUpload" });
  const { showGrowl } = useGrowlStoreActions();

  const handleSuccess = (response) => {
    if (response && response.resource_gid) {
      const path = gidToPath(response.resource_gid);
      navigate(path);
      return;
    }

    fetchChangeRequests({
      profileId: currentProfile.id,
      diffOnly: true,
      applied: false,
      page: 1,
      perPage: 1
    })
      .then(({ entries }) => {
        const changeRequest = head(entries);
        navigate(`/change_requests/${changeRequest?.id}`);
      })
      .catch(() => {
        showGrowl({
          message: t("dataAlreadyImported"),
          kind: "success"
        });
        navigate("/profiles/me");
      });
  };

  const handleTimeout = () => navigate("/profiles/me");

  return (
    <CVUpload
      processingMessage={t("processingCV")}
      handleSuccess={handleSuccess}
      handleTimeout={handleTimeout}
    />
  );
};
